import React, {useEffect} from 'react'
import {Button, Dialog, Loading} from '@startlibs/components'
import {StudyCard} from '../pages/worklist/StudyCard'
import {consumeRedirect, useAsyncDownloadStore, useDownloadError} from '../hooks/useAsyncDownload'
import {usePrevious, useToggle} from '@startlibs/core'
import styled from 'styled-components'
import {SuccessIcon} from './Styled'

const DownloadLoadingNotification = styled.div`
  z-index: 1000;
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  background: rgba(0,0,0,0.75);
  padding: 1.25rem;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  font-weight: 600;
  min-height: 52px;
  ${Loading} {
    margin-right: 1rem;
  }
  ${SuccessIcon} {
    margin-right: 1rem;
    font-size: 17px;
    width: 22px;
    height: 22px;
    line-height: 23px;
  }
`


export const AsyncDownloadManager = () => {

  const [downloadError, setDownloadError] = useDownloadError()
  const [asyncStore] = useAsyncDownloadStore()
  const prevAsyncStore = usePrevious(asyncStore) || []
  const downloadStarted = useToggle()

  useEffect(() => {
    if (!asyncStore.length && prevAsyncStore.length) {
      downloadStarted.open();
      downloadStarted.closeAfter(1500);
    }
  },[asyncStore.length])

  useEffect(() => {
    if (asyncStore.length > 0) {
      const onUnload = function (e) {
        if (consumeRedirect()) {
          return;
        }
        // Cancel the event
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = '';
      }
      window.addEventListener('beforeunload', onUnload);
      return () => window.removeEventListener('beforeunload', onUnload)
    }
  },[asyncStore.length])

  const cancelDownloadError = () => {
    downloadStarted.close()
    downloadError.map(([study, , cancel]) => cancel())
    setDownloadError([])
  }

  const retryDownloadError = () => {
    downloadStarted.close()
    downloadError.map(([study, retry]) => retry())
    setDownloadError([])
  }

  return <>
    {asyncStore.length > 0 && <DownloadLoadingNotification>
      <Loading size={22} white/>Preparing download
    </DownloadLoadingNotification>}
    {downloadStarted.isOpen && !downloadError.length && <DownloadLoadingNotification>
      <SuccessIcon icon="check"/>Download started
    </DownloadLoadingNotification>}
    {
      downloadError.length > 0 &&
      <Dialog
        title="Download attempt failed"
        closeDialog={cancelDownloadError}
        footer={<>
          <Button onClick={cancelDownloadError}>Close</Button>
          <Button highlight onClick={retryDownloadError}>Retry{downloadError.length > 1 && " All"}</Button>
        </>}
      >
        <p>The download attempt for the following {downloadError.length > 1 ? "studies" : "study"} has failed:</p>
        {downloadError.map(([study]) => <StudyCard key={study.id} study={study} patientLabel/>)}
        <p>Please check your internet connection and try again.</p>
      </Dialog>
    }
  </>
}